/**
 * Thẻ liên hệ trong admin — khách, BĐS liên quan, trạng thái và hành động xử lý.
 */
import { ButtonSpinner } from '../Common/ButtonSpinner';
import { formatCurrency } from '../../shared/utils/formatCurrency';

const PLACEHOLDER_IMAGE =
  'https://images.unsplash.com/photo-1560518883-ce09059eeffa?auto=format&fit=crop&w=480&q=80';

const formatContactDate = (value) => {
  if (!value) {
    return '';
  }

  return new Intl.DateTimeFormat('vi-VN', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }).format(new Date(value));
};

export const AdminContactCard = ({
  contact,
  contactStatus,
  contactsText,
  admin,
  common,
  isUpdating,
  onStatusChange,
  onViewProperty,
}) => {
  const property = contact.property;
  const coverImage = property?.images?.[0]?.url || PLACEHOLDER_IMAGE;

  return (
    <article className={`admin-contact-card admin-contact-card--${contact.status}`}>
      <div className="admin-contact-card-header">
        <div className="admin-contact-card-customer">
          <div className="admin-contact-card-avatar" aria-hidden="true">
            {contact.name?.charAt(0)?.toUpperCase() || '?'}
          </div>
          <div>
            <h2>{contact.name}</h2>
            <p>{formatContactDate(contact.created_at)}</p>
          </div>
        </div>
        <span className={`admin-contact-status-badge admin-contact-status-badge--${contact.status}`}>
          {contactStatus[contact.status] || contact.status}
        </span>
      </div>

      <div className="admin-contact-card-meta">
        <a className="admin-contact-meta-item" href={`mailto:${contact.email}`}>
          <svg viewBox="0 0 24 24" width="16" height="16" fill="none" aria-hidden="true">
            <path
              d="M4 7.5A2.5 2.5 0 016.5 5h11A2.5 2.5 0 0120 7.5v9A2.5 2.5 0 0117.5 19h-11A2.5 2.5 0 014 16.5v-9z"
              stroke="currentColor"
              strokeWidth="1.75"
            />
            <path d="M5 8l7 5 7-5" stroke="currentColor" strokeWidth="1.75" strokeLinejoin="round" />
          </svg>
          {contact.email}
        </a>
        <span className="admin-contact-meta-item">
          <svg viewBox="0 0 24 24" width="16" height="16" fill="none" aria-hidden="true">
            <path
              d="M8.5 4.5h7a2 2 0 012 2v11a2 2 0 01-2 2h-7a2 2 0 01-2-2v-11a2 2 0 012-2z"
              stroke="currentColor"
              strokeWidth="1.75"
            />
            <path d="M10 7h4" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" />
          </svg>
          {contact.phone || common.noPhone}
        </span>
      </div>

      {property ? (
        <button
          className="admin-contact-property"
          type="button"
          onClick={() => onViewProperty(contact)}
        >
          <img src={coverImage} alt="" loading="lazy" />
          <span className="admin-contact-property-copy">
            <strong>{property.title}</strong>
            <span>
              {[property.category?.name, property.location].filter(Boolean).join(' · ')}
            </span>
            {property.price ? <em>{formatCurrency(property.price)}</em> : null}
          </span>
        </button>
      ) : (
        <div className="admin-contact-property admin-contact-property--empty">
          <span>{contactsText.noProperty}</span>
        </div>
      )}

      <blockquote className="admin-contact-message">{contact.message}</blockquote>

      <div className="admin-contact-card-footer">
        <label className="admin-contact-status-field">
          <span>{admin.statusColumn}</span>
          <select
            value={contact.status}
            disabled={contact.status === 'replied' || isUpdating}
            onChange={(event) => onStatusChange(contact, event.target.value)}
          >
            <option value="new">{contactStatus.new}</option>
            <option value="read">{contactStatus.read}</option>
            <option value="replied">{contactStatus.replied}</option>
          </select>
        </label>

        {property ? (
          <button
            className="admin-contact-action"
            type="button"
            disabled={isUpdating}
            onClick={() => onViewProperty(contact)}
          >
            {isUpdating && <ButtonSpinner />}
            {admin.viewPropertyInfo}
          </button>
        ) : null}
      </div>
    </article>
  );
};
